import BaseBackdropLoader from '@components/common/atoms/BaseBackdropLoader';
import BaseContainer from '@components/common/atoms/container/BaseContainer';
import LoginView from '@components/membership/components/login/LoginView';
import OrderCartDrawer from '@components/order/components/order-cart/mobile/OrderCartDrawer';
import { accessTokenKey } from '@const/localStorage';
import useDevice from '@hooks/useDevice';
import { useRootStore } from '@hooks/useRootStore';
import { getLocalStorageItem } from '@utils/localStorageUtil';
import { observer } from 'mobx-react-lite';
import React, { Suspense } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Footer from './footer/Footer';
import ResponsiveAppBar from './header/AppBar';

interface LayoutProps {
    isProtected?: boolean;
}

const Layout: React.FC<LayoutProps> = observer(({ isProtected = false }) => {
    const { isWebDevice } = useDevice();
    const navigate = useNavigate();

    const accessToken = getLocalStorageItem(accessTokenKey);
    const { authorizationStore } = useRootStore();
    const { isUserLoggedIn } = authorizationStore;

    if (isProtected) {
        const isRestricted = accessToken === undefined || accessToken === null;
        if (isRestricted) {
            navigate("/");
        }

        if (!isUserLoggedIn) {
            return <BaseBackdropLoader isLoading={true} />
        }
    }

    return (
        <>
            <ResponsiveAppBar />
            <BaseContainer useLeftAndRightPadding useTopAndBottomPadding>
                <Suspense fallback={<BaseBackdropLoader isLoading />}>
                    <Outlet />
                </Suspense>
            </BaseContainer>
            <Footer />
            {!isWebDevice && <OrderCartDrawer />}
            <LoginView />
        </>
    )
})

export default Layout;